<template>
  <div>
    <px-view-header title="Detalhes da cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary"
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && resposta && cotacao">
      <px-contratacao-dados-resposta :resposta="resposta"/>
      <px-contatacao-cadastro class="mt-3"
                              :resposta="resposta"
                              :cotacao="cotacao"/>
    </div>
  </div>
</template>

<script>
import RespostaService from '../detalhes/respostas/resposta-frete-service';
import ContratacaoDadosResposta from './ContratacaoDadosResposta.vue';
import ContatacaoCadastro from './ContatacaoCadastro.vue';
import CotacaoFreteService from '../cotacao-frete-service';

export default {
  data() {
    return {
      cotacaoId: this.$route.params.id,
      idResposta: this.$route.params.idResposta,
      loading: false,
      resposta: null,
      cotacao: null,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        {
          text: 'Cotações de frete',
          to: '/cotacoes-fretes',
        },
        { text: 'Contratação de frete' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.gestao-frete.cotacoes.detalhes.resposta',
        params: {
          id: this.cotacaoId,
          idResposta: this.idResposta,
        },
      });
    },
    getResposta() {
      this.loading = true;
      RespostaService.getResposta(this.cotacaoId, this.idResposta)
        .then((response) => {
          this.resposta = response.data;
          return this.getCotacao();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCotacao() {
      return CotacaoFreteService.getCotacao(this.cotacaoId)
        .then(({ data }) => {
          this.cotacao = data;
        });
    },
  },
  created() {
    this.getResposta();
  },
  components: {
    pxContratacaoDadosResposta: ContratacaoDadosResposta,
    pxContatacaoCadastro: ContatacaoCadastro,
  },
};
</script>
